import { render, staticRenderFns } from "./ListaGestionesPersona.vue?vue&type=template&id=fc1b8b34"
import script from "./ListaGestionesPersona.vue?vue&type=script&lang=js"
export * from "./ListaGestionesPersona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports